"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const Sentry = __importStar(require("./Sentry"));
//
// components
//
const LogIn = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/onboarding/Login'))));
const Register = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/onboarding/Register'))));
const PaymentMethod = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/onboarding/PaymentMethod'))));
const PasswordRecovery = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/onboarding/PasswordRecovery'))));
const PasswordReset = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/onboarding/PasswordReset'))));
const Dashboard = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/Dashboard'))));
const LoadingSpinner_1 = __importDefault(require("./components/general/LoadingSpinner"));
const useDelighted_1 = require("./components/useDelighted");
//
// styles
//
const StyledLoadingContainer_1 = require("./StyledLoadingContainer");
const tokenHeader_1 = require("./tokenHeader");
const queryDefinitions_1 = require("./queryDefinitions");
const withAccount_1 = require("./components/withAccount");
const AccountContext_1 = require("contexts/AccountContext");
const Loading = () => (react_1.default.createElement(StyledLoadingContainer_1.StyledLoadingContainer, null,
    react_1.default.createElement(LoadingSpinner_1.default, null)));
// eslint-disable-next-line react/no-multi-comp
const RequireAuth = ({ children }) => {
    const { account } = (0, AccountContext_1.useAccount)();
    const location = (0, react_router_dom_1.useLocation)();
    if (!account) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return react_1.default.createElement(react_router_dom_1.Navigate, { replace: true, state: { from: location }, to: '/login' });
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
// eslint-disable-next-line react/no-multi-comp
const Root = ({ isLoggedIn, account }) => {
    var _a;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((options?... Remove this comment to see the full error message
    const [getUser, { data }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_USER);
    const ldClient = (0, launchdarkly_react_client_sdk_1.useLDClient)();
    const userId = (_a = data === null || data === void 0 ? void 0 : data.currentUser) === null || _a === void 0 ? void 0 : _a.id;
    (0, useDelighted_1.useDelighted)({ mount: isLoggedIn });
    (0, react_1.useEffect)(() => {
        if (isLoggedIn) {
            // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
            getUser();
        }
    }, [isLoggedIn]);
    (0, react_1.useEffect)(() => {
        if (userId) {
            Sentry.setUser(userId);
        }
        else {
            Sentry.clearUser();
        }
    }, [userId]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        if (!data) {
            return;
        }
        if ((0, isEmpty_1.default)(account)) {
            return;
        }
        const { currentUser } = data;
        try {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'pendo' does not exist on type 'Window & ... Remove this comment to see the full error message
            (_a = window.pendo) === null || _a === void 0 ? void 0 : _a.initialize({
                visitor: {
                    id: currentUser.id,
                    email: currentUser.email,
                    full_name: currentUser.name,
                    admin_role: currentUser.admin
                },
                account: {
                    id: account.id,
                    name: account.name
                }
            });
        }
        catch (_d) {
            // eslint-disable-next-line no-console
            console.log('Pendo is disabled!');
        }
        try {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'freshpaint' does not exist on type 'Window & ... Remove this comment to see the full error message
            (_b = window.freshpaint) === null || _b === void 0 ? void 0 : _b.identify(currentUser.id, {
                email: currentUser.email,
                full_name: currentUser.name,
                admin_role: currentUser.admin,
                account: {
                    id: account.id,
                    name: account.name
                }
            });
        }
        catch (_e) {
            // eslint-disable-next-line no-console
            console.log('Freshpaint is disabled!');
        }
        try {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'delighted' does not exist on type 'Window & ... Remove this comment to see the full error message
            (_c = window.delighted) === null || _c === void 0 ? void 0 : _c.survey({
                email: currentUser.email,
                name: currentUser.name,
                properties: { accountName: account.name }
            });
        }
        catch (_f) {
            // eslint-disable-next-line no-console
            console.log('Delighted is disabled!');
        }
    }, [data, account]);
    (0, react_1.useEffect)(() => {
        if (!data) {
            return;
        }
        if ((0, isEmpty_1.default)(account)) {
            return;
        }
        const { currentUser } = data;
        const context = {
            kind: 'user',
            key: currentUser.id,
            name: currentUser.name,
            email: currentUser.email,
            admin: currentUser.admin,
            accountName: account.name
        };
        ldClient === null || ldClient === void 0 ? void 0 : ldClient.identify(context);
    }, [data, account, ldClient]);
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading, null) },
                    react_1.default.createElement(LogIn, null)), path: 'login' }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading, null) },
                    react_1.default.createElement(Register, null)), path: 'register' }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading, null) },
                    react_1.default.createElement(PaymentMethod, null)), path: 'payment' }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading, null) },
                    react_1.default.createElement(PasswordRecovery, null)), path: 'password_recovery' }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading, null) },
                    react_1.default.createElement(PasswordReset, null)), path: 'password_reset/:code' }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading, null) },
                        react_1.default.createElement(Dashboard, null))), path: '*' }))));
};
const WithLDProvider = (0, launchdarkly_react_client_sdk_1.withLDProvider)({
    clientSideID: env.LAUNCH_DARKLY_CLIENT_SIDE_ID,
    context: {
        kind: 'user',
        anonymous: true
    },
    options: {
        bootstrap: 'localStorage'
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
})(Root);
exports.default = (0, withAccount_1.withAccount)(WithLDProvider);
